module.exports = __webpack_public_path__ + "img/Books.c6df64fc.gif";